import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ApiFragment, ShBaseFormComponent } from '@stylehaven/components';
import { WebserviceConfig } from '../../../entities/webservice-config.entity';

@Component({
    standalone: false,
    selector: 'med-form-webservice',
    templateUrl: './form-webservice.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormWebserviceComponent extends ShBaseFormComponent implements OnInit {
    @Input() webserviceConfig: WebserviceConfig;
    @Input() records: ApiFragment[];
    @Input() multiple: boolean;

    // Messages
    @Input() placeholderMsg?: string;
    @Input() maxValuesMsg?: string;
    @Input() searchLabel: string;
    @Input() declare disabledMsg?: string;
}
